export function handleComplexPagination(base = 4, totalPages, currentPage, totalItemsArray, isMobile = false) {
    const EdgePages = base - 1;
    const result = [...totalItemsArray];
    if (currentPage <= base) {
        result.splice(base, totalPages - 1 - base, -1);
    }
    if (currentPage >= totalPages - EdgePages) {
        result.splice(1, totalPages - 1 - base, -EdgePages);
    }
    if (currentPage > base && currentPage < totalPages - EdgePages) {
        if (isMobile) {
            result.splice(1, result.indexOf(currentPage) - EdgePages + 1, -EdgePages);
            result.splice(result.indexOf(currentPage) + EdgePages - 1, result.length - (result.indexOf(currentPage) + base), -1);
        }
        else {
            result.splice(1, result.indexOf(currentPage) - EdgePages, -EdgePages);
            result.splice(result.indexOf(currentPage) + EdgePages, result.length - (result.indexOf(currentPage) + base), -1);
        }
    }
    return result;
}
